import { BaseOption } from '@/hooks/useTypeToOptions';
import {
  FormSelect,
  FormSelectProps,
  SelectProps,
} from '@moneyforward/ap-frontend-components';
import { memo, useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from '@/i18n';
export type AIProgressTypeValue = 'ai_suggest' | 'ai_ocr' | 'no_assistance';

export type Props<TFieldValues extends FieldValues> = {
  selectProps?: Omit<FormSelectProps<TFieldValues>['selectProps'], 'options'>;
} & Omit<FormSelectProps<TFieldValues>, 'selectProps' | 'label'>;

const _AIProgressType = <TFieldValues extends FieldValues>({
  selectProps: _selectProps,
  ...rest
}: Props<TFieldValues>) => {
  const { t } = useTranslation();
  const AI_PROGRESS_TYPE_OPTIONS: BaseOption[] = useMemo(
    () => [
      {
        label: t('ai_suggest'),
        value: 'ai_suggest',
      },
      {
        label: t('ai_ocr'),
        value: 'ai_ocr',
      },
      {
        label: t('no_assistance'),
        value: 'no_assistance',
      },
    ],
    [t]
  );

  const selectProps: SelectProps = useMemo(() => {
    return {
      onSearchDebounceWait: 600,
      comboBox: false,
      placeholder: '',
      inputPlaceholder: '',
      ..._selectProps,
      options: AI_PROGRESS_TYPE_OPTIONS,
      isAllowClear: false,
      mode: 'single',
      selectAll: undefined,
      defaultValue: 'ai_ocr',
      selectAllLabel: undefined,
    };
  }, [AI_PROGRESS_TYPE_OPTIONS, _selectProps]);

  return <FormSelect<TFieldValues> selectProps={selectProps} {...rest} />;
};

_AIProgressType.displayName = '_AIProgressType';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const AIProgressType = memo((props) => (
  <_AIProgressType {...props} />
)) as typeof _AIProgressType;

AIProgressType.displayName = 'AIProgressType';
